export default "__VITE_ASSET__D9JZ0GVg__ 400w";